import React from 'react';
import { IconButton  } from "@material-ui/core";
import { Menu } from "@material-ui/core";
import { MenuItem } from "@material-ui/core";
import { ListItemIcon } from "@material-ui/core";
import MoreVertIcon from '@material-ui/icons/MoreVert';
import DeleteIcon from '@material-ui/icons/Delete';
import DvrIcon from '@material-ui/icons/Dvr';
import { Divider} from "@material-ui/core";
import { Typography } from "@material-ui/core";
import { FormattedMessage } from "react-intl";

export default ({ row, onDeleteRow, onSummaryRow, size, editBgColor, deleteBgColor }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const deleteRow = () => {
        if (onDeleteRow) {
            onDeleteRow(row);
            setAnchorEl(null);
        }
    };

    const summaryRow = () => {
        if (onSummaryRow) {
            onSummaryRow(row);
            setAnchorEl(null);
        }
    };

    return (
        <div>
            <IconButton
                aria-label="more"
                aria-controls="long-menu" // flaticon-layer
                aria-haspopup="true"
                onClick={handleClick}
                size={size}
            >
                <MoreVertIcon />
            </IconButton>
            <Menu
                id="menu"
                getContentAnchorEl={null}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >

                <MenuItem onClick={summaryRow} style={{ backgroundColor: '#' + editBgColor }}>
                    <ListItemIcon>
                        <DvrIcon fontSize="small" color="primary" />
                    </ListItemIcon>
                    <Typography variant="inherit">
                        <FormattedMessage id="CustomMaterialMenuSummary" defaultMessage="Summary" />
                    </Typography>
                </MenuItem>

                <Divider />

                <MenuItem onClick={deleteRow} style={{ backgroundColor: '#' + deleteBgColor }}>
                    <ListItemIcon>
                        <DeleteIcon fontSize="small" color="error" />
                    </ListItemIcon>
                    <Typography variant="inherit">
                        <FormattedMessage id="CustomMaterialMenuDelete" defaultMessage="Delete" />
                    </Typography>
                </MenuItem>
            </Menu>
        </div>
    );
};